(() => {
  const menuButton = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('#mobile-menu');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const nextOpen = mobileMenu.hidden;
      mobileMenu.hidden = !nextOpen;
      menuButton.setAttribute('aria-expanded', String(nextOpen));
      menuButton.setAttribute('aria-label', nextOpen ? 'Cerrar menú' : 'Abrir menú');
    });
    mobileMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      mobileMenu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Abrir menú');
    }));
  }

  const drawCountdown = document.querySelector('[data-draw-countdown]');
  if (drawCountdown) {
    const target = Date.parse(drawCountdown.dataset.countdownTarget);
    const units = {
      days: drawCountdown.querySelector('[data-countdown-days]'),
      hours: drawCountdown.querySelector('[data-countdown-hours]'),
      minutes: drawCountdown.querySelector('[data-countdown-minutes]'),
      seconds: drawCountdown.querySelector('[data-countdown-seconds]')
    };
    const status = drawCountdown.querySelector('[data-countdown-status]');
    const pad = value => String(value).padStart(2, '0');
    const updateCountdown = () => {
      if (!Number.isFinite(target)) return;
      const now = Date.now();
      const totalSeconds = Math.max(0, Math.ceil((target - now) / 1000));
      units.days.textContent = String(Math.floor(totalSeconds / 86400));
      units.hours.textContent = pad(Math.floor(totalSeconds % 86400 / 3600));
      units.minutes.textContent = pad(Math.floor(totalSeconds % 3600 / 60));
      units.seconds.textContent = pad(totalSeconds % 60);
      if (now >= target) {
        if (drawCountdown.dataset.countdownKind === 'sale-close') {
          status.textContent = 'La venta de números terminó. Sorteo programado para las 22:00, hora de Chile, en vivo por Instagram @nosfuimosalab.';
          const heading = drawCountdown.querySelector('[data-countdown-heading]');
          if (heading) heading.textContent = 'La venta terminó.';
          const purchaseForm = document.querySelector('#raffle-form');
          if (purchaseForm) {
            purchaseForm.querySelectorAll('button[type="submit"]').forEach(button => {
              button.disabled = true;
              button.textContent = 'Venta cerrada';
            });
          }
        } else {
          status.textContent = 'Llegó la hora programada del sorteo. Consulta su estado y resultado en Rifafácil.';
        }
      }
    };
    updateCountdown();
    setInterval(updateCountdown, 1000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) updateCountdown();
    });
  }

  const form = document.querySelector('#raffle-form');
  const quantityInput = form?.querySelector('#raffle-quantity');
  const total = form?.querySelector('[data-total]');
  const error = form?.querySelector('[data-form-error]');
  const buyButton = form?.querySelector('[data-buy-button]');
  const packOptions = [...(form?.querySelectorAll('input[name="raffle_pack"]') || [])];
  const packsEnabled = packOptions.length > 0;
  const upsellDialog = document.querySelector('[data-pack-upsell]');
  const upsellPackButtons = [...(upsellDialog?.querySelectorAll('[data-upsell-pack]') || [])];
  const variantId = Number(form?.querySelector('input[name="id"]')?.value);
  let max = Number(quantityInput?.dataset.max ?? quantityInput?.max ?? Number.POSITIVE_INFINITY);
  let isSubmitting = false;
  const unitPriceCents = Number(total?.dataset.unitPrice) || 0;
  const formatPrice = value => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(value);
  const selectedPack = () => packOptions.find(option => option.checked && !option.disabled);
  const normalizedQuantity = () => packsEnabled
    ? Number(selectedPack()?.value) || 1
    : Math.min(max, Math.max(1, Math.floor(Number(quantityInput?.value) || 1)));
  const update = () => {
    if (!quantityInput || !total) return 0;
    if (packsEnabled && !selectedPack()) {
      total.textContent = 'Agotado';
      buyButton.disabled = true;
      return 0;
    }
    const quantity = normalizedQuantity();
    quantityInput.value = String(quantity);
    const priceCents = packsEnabled ? Number(selectedPack()?.dataset.packPriceCents) : quantity * unitPriceCents;
    total.textContent = formatPrice(priceCents / 100);
    if (packsEnabled) buyButton.textContent = `Ir al pago con ${quantity} ${quantity === 1 ? 'número' : 'números'}`;
    return quantity;
  };
  const updatePackAvailability = () => {
    if (!packsEnabled) return;
    packOptions.forEach(option => { option.disabled = Number(option.value) > max; });
    upsellPackButtons.forEach(button => { button.disabled = Number(button.dataset.upsellPack) > max; });
    if (!selectedPack()) {
      const fallback = [...packOptions].filter(option => !option.disabled).sort((a, b) => Number(b.value) - Number(a.value))[0];
      if (fallback) fallback.checked = true;
    }
  };
  if (!form) return;
  if (packsEnabled) {
    packOptions.forEach(option => option.addEventListener('change', () => {
      update();
      if (option.checked && option.value === '1' && typeof upsellDialog?.showModal === 'function' && !upsellDialog.open) {
        upsellDialog.showModal();
        upsellDialog.querySelector('[data-upsell-heading]')?.focus();
      }
    }));
    upsellDialog?.querySelector('[data-upsell-close]')?.addEventListener('click', () => upsellDialog.close());
    upsellDialog?.addEventListener('click', event => { if (event.target === upsellDialog) upsellDialog.close(); });
    upsellDialog?.querySelector('[data-upsell-single]')?.addEventListener('click', () => {
      upsellDialog.close();
      form.requestSubmit();
    });
    upsellPackButtons.forEach(button => button.addEventListener('click', () => {
      const option = packOptions.find(pack => pack.value === button.dataset.upsellPack);
      if (!option || option.disabled) return;
      option.checked = true;
      update();
      upsellDialog.close();
      form.requestSubmit();
    }));
    updatePackAvailability();
  } else {
    form.querySelector('[data-qty-down]').addEventListener('click', () => { quantityInput.value = String(normalizedQuantity() - 1); update(); });
    form.querySelector('[data-qty-up]').addEventListener('click', () => { quantityInput.value = String(normalizedQuantity() + 1); update(); });
    quantityInput.addEventListener('change', update);
  }
  update();
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (isSubmitting) return;
    error.hidden = true;
    const quantity = update();
    if (!unitPriceCents || !variantId || max < 1 || quantity > max || (packsEnabled && !selectedPack())) {
      error.textContent = 'No podemos confirmar el precio o la disponibilidad. Actualiza la página e inténtalo otra vez.';
      error.hidden = false;
      return;
    }
    isSubmitting = true;
    buyButton.disabled = true;
    buyButton.textContent = 'Preparando el pago…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const requestCart = async (path, body) => {
        const response = await fetch(`${root}${path}`, {
          method: body ? 'POST' : 'GET',
          headers: body ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: body ? JSON.stringify(body) : undefined
        });
        if (!response.ok) throw new Error('No se pudo actualizar el carrito. Revisa la disponibilidad e inténtalo otra vez.');
        return response.json();
      };
      if (packsEnabled) {
        const before = await requestCart('cart.js');
        if (before.items.some(item => Number(item.variant_id) !== variantId)) {
          throw new Error('El carrito contiene otros productos. Finaliza o vacía ese pedido antes de elegir un pack.');
        }
        const matching = before.items.filter(item => Number(item.variant_id) === variantId);
        for (const item of matching.slice(1)) await requestCart('cart/change.js', { id: item.key, quantity: 0 });
        const current = matching.length ? await requestCart('cart.js') : before;
        const existing = current.items.find(item => Number(item.variant_id) === variantId);
        if (existing) await requestCart('cart/change.js', { id: existing.key, quantity });
        else await requestCart('cart/add.js', { items: [{ id: variantId, quantity }] });
        const after = await requestCart('cart.js');
        const raffleLines = after.items.filter(item => Number(item.variant_id) === variantId);
        const actualQuantity = raffleLines.reduce((sum, item) => sum + item.quantity, 0);
        const expectedPrice = Number(selectedPack().dataset.packPriceCents);
        if (actualQuantity !== quantity || after.total_price !== expectedPrice) {
          throw new Error('El pack aún no muestra el precio correcto en Shopify. No continúes al pago; inténtalo más tarde.');
        }
      } else await requestCart('cart/add.js', { items: [{ id: variantId, quantity }] });
      window.location.assign(`${root}checkout`);
    } catch (caught) {
      isSubmitting = false;
      error.textContent = caught.message || 'Ocurrió un error. Inténtalo otra vez.';
      error.hidden = false;
      buyButton.disabled = false;
      if (packsEnabled) update();
      else buyButton.textContent = 'Comprar stickers';
    }
  });
})();
